import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  actionsWrapperStyle: {
    height: 50,
    padding: '4px 25px 0px 25px',
    backgroundColor: theme.palette.neutralLight,
  },
}));
